import { pilot } from '~/services/serviceInstances';

interface Request {
  bucketName: string;
}

type Response = any;

export const getBucketInfo = async ({
  bucketName,
}: Request): Promise<Response> => {
  const response = await pilot.get(`client/get-bucket-info/${bucketName}/`);
  return response;
};
